// extracted by mini-css-extract-plugin
module.exports = {"page":"Page_page__yjv6Z","rotation":"Page_rotation__9BSJ4"};